import {LOCALES, API_URL} from 'providers/ferries/autocompleteResultsBasedOnTypedLanguage/constants';
import request from 'superagent';
import {isoCurrency} from 'helpers/stableValues';

const interleaveArrays = (arr1, arr2) => {
  const result = [];
  const maxLength = Math.max(arr1.length, arr2.length);

  for (let i = 0; i < maxLength; i++) {
    if (i < arr1.length) {
      result.push(arr1[i]);
    }
    if (i < arr2.length) {
      result.push(arr2[i]);
    }
  }

  return result;
};

const getData = () => LOCALES.map((locale) =>
  request.get(API_URL).query({
    preferredLocale: locale,
    preferredCurrency: isoCurrency()
  }).then(({body}) => body.results)
);

const getPortsBilingual = () => Promise.all(getData()).then((results) => interleaveArrays(results[0], results[1])
).finally(() => []);

export {getPortsBilingual};
